<script setup lang="ts">
import { JUSYOU_REKI } from "@/constants/contest";

const [{ data: maxYear }, { data }] = await Promise.all([
  useFetch("/api/contest/maxYear"),
  useFetch(() => `/api/contest`),
]);

// コンテスト年度配列
const yearArray: { id: number; name: string }[] = [];
for (var i = maxYear.value || 2000; i >= 2000; i--) {
  yearArray.push({ id: i, name: `${i}年度` });
}

// パンくず
useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: "コンテスト受賞歴", path: "/contents.php/contest" },
]);

useHead({
  title: `LIXIL、YKKAPなど大手メーカー外構デザインコンペ${JUSYOU_REKI}年連続受賞中 。ファミリー庭園の評価`,
  meta: [
    {
      name: "description",
      content: `ファミリー庭園の施工例コンテスト受賞歴を紹介します`,
    },
  ],
});
</script>

<template>
  <div class="p-contest wrapper mb-14">
    <TextPageTitle class="hidden pc:block">受賞歴</TextPageTitle>
    <div class="flex flex-col pc:flex-row">
      <ContestMenu
        v-if="data"
        class="pc:w-1/4"
        :year-array="yearArray"
        :list="data"
      >
      </ContestMenu>
      <div v-if="data && maxYear" class="px-8 pc:w-3/4">
        <ContestListYear
          v-for="year in yearArray"
          :year="year.id"
          :old="year.id < maxYear - 3"
          :list="data?.filter((item) => item.href.match(year.id.toString()))"
        />
      </div>
    </div>
  </div>
</template>
